import { createSelector } from 'reselect';
import { ROLES } from "./appConstants";

const moduleSelector = state => state.app;

export const getAppIsInited = createSelector(moduleSelector, state => state.inited);

export const getAppUser = createSelector(moduleSelector, state => state.user);
export const getUserIsVerified = createSelector(moduleSelector, state => state.user.group !== ROLES.CLIENT || state.user?.verified);
export const getUserIsClient = createSelector(moduleSelector, state => state.user.group === ROLES.CLIENT);

export const getAccessLevels = createSelector(moduleSelector, state => state.accessLevels);
